(function () {
  const menuActions = (menu) => {
    if (!menu) {
      return;
    }

    const action = menu.querySelector('.sub-page-menu__action');
    const nav = menu.querySelector('.sub-page-menu__menu');

    if (!action) {
      return;
    }

    action.addEventListener('click', (e) => {
      e.preventDefault();
      action.classList.toggle('is-active');
      nav.classList.toggle('is-active');
    });

    const menuItems = menu.querySelectorAll('.has-sub');

    if (!menuItems) {
      return;
    }

    menuItems.forEach((item) => {
      item.querySelector('a').addEventListener('click', (e) => {
        e.preventDefault();

        item.classList.toggle('is-active');
      });
    });
  };
  const menus = document.querySelectorAll('.sub-page-menu');

  if (menus?.length >= 1) {
    menus.forEach((menu) => menuActions(menu));
  }
})();
